module.exports = "\r\n.form-group{\r\n    margin: 10px 20px;\r\n}\r\n.form-group a{\r\n    color :#0056b3;\r\n    cursor: pointer;\r\n    -webkit-text-decoration: #0056b3;\r\n            text-decoration: #0056b3;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/functions/lience-reuest/licence-request-menu/licence-request-menu.component.css
// module id = ./src/app/pages/functions/lience-reuest/licence-request-menu/licence-request-menu.component.css
// module chunks = main